import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-300";

export const PrimaryButton = ({ to, children, className = "", testId, ...rest }) => {
  const cls = `${base} bg-white text-black hover:opacity-90 ${className}`;
  const content = (
    <>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
    </>
  );
  if (to)
    return (
      <Link to={to} data-testid={testId} className={`group ${cls}`} {...rest}>
        {content}
      </Link>
    );
  return (
    <button data-testid={testId} className={`group ${cls}`} {...rest}>
      {content}
    </button>
  );
};

export const SecondaryButton = ({ to, children, className = "", testId, ...rest }) => {
  const cls = `${base} border border-white/20 text-white hover:border-white/40 hover:bg-white/5 ${className}`;
  if (to)
    return (
      <Link to={to} data-testid={testId} className={cls} {...rest}>
        {children}
      </Link>
    );
  return (
    <button data-testid={testId} className={cls} {...rest}>
      {children}
    </button>
  );
};
